module.exports = __webpack_public_path__ + "img/mention.60379eca.svg";